import appointmentManagment from './appointmentManagment';
import billingAdjustmentManagement from './billingAdjustmentManagement';
import billingHistory from './billingHistory';
import certificationLoad from './certificationLoad';
import compensatoryService from './compensatoryService';
import dispenseManagement from './dispenseManagement';
import periodEnd from './periodEnd';
import proposal from './proposal';
import reinbursement from './reinbursement';
import referralManagement from './referralManagement';
import referralValidity from './referralValidity';
import trainingHistory from './trainingHistory';
import umesr from './umesr';
import visitRegistry from './visitRegistry';
import serviceSatisfactionQuestionnaire from './serviceSatisfactionQuestionnaire';
import specialistAvailabilityCalendar from './specialistAvailabilityCalendar';
import visitRegistrationCalendar from './visitRegistrationCalendar';
import vocationalEvaluation from './vocationalEvaluation';

export default [
  ...visitRegistry,
  ...certificationLoad,
  ...periodEnd,
  ...billingHistory,
  ...referralManagement,
  ...referralValidity,
  ...trainingHistory,
  ...umesr,
  ...compensatoryService,
  ...dispenseManagement,
  ...proposal,
  ...reinbursement,
  ...billingAdjustmentManagement,
  ...appointmentManagment,
  ...serviceSatisfactionQuestionnaire,
  ...specialistAvailabilityCalendar,
  ...visitRegistrationCalendar,
  ...vocationalEvaluation,
];
